import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { Link } from '@bd/bdcore-named-routes';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import numeral from 'numeral';
// import { SanitizeHtml } from '@bd/bdcore-utilities';
import RawPlatMap from '@bd/bdui-platmap';

import { typography, colors } from '../../styles';

const PlatMap = withData(
  {
    community: true,
    lots: true,
    homes: true,
  },
  {
    community: true,
  },
)(RawPlatMap);

const styles = css`
  padding: 40px 0;
  @media(min-width: 992px) {
    padding: 70px 0;
  }

  h3, h4 {
    text-align: center;
  }

  .SitePlanModal_platMap .leaflet-container {
    height: 600px;
    z-index: 1;
  }

  .SmothLink_wrapper {
    padding: 20px 0;
    @media(min-width: 768px) {
      padding: 50px 0;
    }
  }

  .leaflet-popup-content-wrapper {
    border-radius: 0;
    .HomePopup_wrapper {
      display: flex;
      .linkout {
        display: flex;
        flex-direction: column;
        font-family: ${typography.SansSerif};
        color: ${colors.body};
        .HomePopup_title {
          color: ${colors.brand2};
          text-align: left;
          font-weight: 700;
          font-size: 19px;
          letter-spacing: 0;
          margin: 0;
        }
        .HomePopup_address {
          font-size: 13px;
          letter-spacing: 0;
          text-transform: uppercase;
        }
        .HomePopup_status {
          text-transform: uppercase;
          font-size: 12;
          font-weight: 800;
          color: ${colors.brand2};
        }
        .Btn_learnMore {
          background-color: ${colors.brand2};
          height: 30px;
          margin-top: 5px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: ${colors.white};
          text-transform: uppercase;
          font-weight: 800;
          font-size: 11px;
        }
        &:hover {
          opacity: 1;
        }
      }
    }
  }
.legend {
  margin-bottom: 15px;
}
.key{
  display: inline-flex;
  align-items: center;
  margin-right: 30px;
}
.circle{
  height: 20px;
  width: 20px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
}
.active {background: blue}
.model {background: purple}
.available-homesite {background: green}
.sold {background: red}
.closed {background: orange}
.reserved {background: yellow}
.default {background: green}


.leaflet-interactive {
  fill-opacity:0.6;
}
`;

// Available Home Sites- Blue
// Model Homes - Purple
// Quick Move-in Homes- Green
// Sold - Red
// Closed - Orange
// Reserved- Yellow

function InteractivePlatMap({ community }) {
  return (
    <div className={styles}>
      <div className="container">
        <div className="SitePlanModal_body">
          <div className="container">
            <div className="row">
              <div className="col-12 SitePlanModal_platMap">

                {/* <div id="site-plan" className="SmothLink_wrapper" />
                <h3 className="CommunitySection_title">Interactive</h3>
                <h4 className="CommunitySection_subtitle Underdog_grey">Site Plan</h4>
                <div className="legend">
                  <div className="key"><span className="circle active" /> Quick Move-in Homes</div>
                  <div className="key"><span className="circle model" /> Model</div>
                  <div className="key"><span className="circle available-homesite"
                 /> Available Homesite</div>
                  <div className="key"><span className="circle sold" /> Sold</div>
                  <div className="key"><span className="circle closed" /> Closed</div>
                  <div className="key"><span className="circle reserved" /> Reserved</div>
                </div> */}
                <PlatMap
                  shapeStatusStyles={{
                    home: {
                      active: {
                        color: 'green',
                      },
                      model: {
                        color: 'purple',
                      },
                      available: {
                        color: 'green',
                      },
                      sold: {
                        color: 'red',
                      },
                      closed: {
                        color: 'orange',
                      },
                      pending: {
                        color: 'yellow',
                      },
                      reserved: {
                        color: 'yellow',
                      },
                      default: {
                        color: 'green',
                      },
                    },
                    lot: {
                      active: {
                        color: 'green',
                      },
                      model: {
                        color: 'purple',
                      },
                      available: {
                        color: 'green',
                      },
                      sold: {
                        color: 'red',
                      },
                      closed: {
                        color: 'orange',
                      },
                      pending: {
                        color: 'yellow',
                      },
                      reserved: {
                        color: 'yellow',
                      },
                      default: {
                        color: 'green',
                      },
                    },
                    active: {
                      color: 'green',
                    },
                    model: {
                      color: 'purple',
                    },
                    available: {
                      color: 'green',
                    },
                    'quick-move-in-home': {
                      color: 'green',
                    },
                    'available-homesite': {
                      color: 'green',
                    },
                    sold: {
                      color: 'red',
                    },
                    closed: {
                      color: 'orange',
                    },
                    reserved: {
                      color: 'yellow',
                    },
                    default: {
                      color: 'green',
                    },
                  }}
                  shapes
                  boundarySize={1}
                  community={community}
                  popup={({ marker }) => (
                    <div className="home-popup HomeCardsList Vertical">
                      {
                        marker.type === 'home' &&
                        <div className="HomePopup_wrapper">
                          <Link className="linkout" name="home-detail" home={marker}>
                            <h4 className="HomePopup_title">{get(marker, 'address.streetAddress')}</h4>
                            <h5 className="HomePopup_address">{get(marker, 'address.addressLocality')}, {get(marker, 'address.addressRegion')} {get(marker, 'address.postalCode')}</h5>
                            {
                              get(marker, 'price') &&
                              <span><strong>Price:</strong> {numeral(get(marker, 'price')).format('$0,0')}</span>
                            }
                            {
                              get(marker, 'lot') &&
                              <span><strong>Lot #:</strong> {get(marker, 'lot')}</span>
                            }
                            {
                              get(marker, 'status') === 'Active' &&
                              <span className="HomePopup_status">Available Now!</span>
                            }
                            <span className="Btn_learnMore">Learn More</span>
                          </Link>
                        </div>
                      }
                      {
                        marker.type === 'lot' &&
                        <div className="HomePopup_wrapper">
                          <div className="linkout" home={marker}>
                            <h4 className="HomePopup_title">{get(marker, 'address.streetAddress')}</h4>
                            <h5 className="HomePopup_address">{get(marker, 'address.addressLocality')}, {get(marker, 'address.addressRegion')} {get(marker, 'address.postalCode')}</h5>
                            {
                              get(marker, 'price') &&
                              <span><strong>Price:</strong> {numeral(get(marker, 'price')).format('$0,0')}</span>
                            }
                            {
                              get(marker, 'lot') &&
                              <span><strong>Lot #:</strong> {get(marker, 'lot')}</span>
                            }
                            {
                              get(marker, 'lotSize') &&
                              <span><strong>Lot Size:</strong> {numeral(get(marker, 'lotSize')).format('0,0')} Sq Ft</span>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  )}
                  tooltip={marker => (
                    <div>
                      {
                        !marker.isLot &&
                        <span>
                          {`${marker.status === 'Active' ? 'Available ' : ''} Home`}
                          <br />
                          {marker.address.streetAddress}
                        </span>
                      }

                      {
                        marker.isLot &&
                        <span>
                          {`${marker.status === 'Active' ? 'Available ' : ''} Lot`}
                          <br />
                          {marker.address.streetAddress}
                        </span>
                      }
                    </div>
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

InteractivePlatMap.propTypes = {
  community: PropTypes.object.isRequired,
};

export default InteractivePlatMap;



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/InteractivePlatMap.js